import React, { useState } from 'react';
import PolicyListPage from './PolicyListPage';
import PolicyEditorPage from './PolicyEditorPage';

const PolicyRegistration = () => {
  const [editorState, setEditorState] = useState(null);

  if (editorState) {
    return (
      <PolicyEditorPage
        sourceId={editorState.sourceId}
        policyType={editorState.policyType}
        onBack={() => setEditorState(null)}
      />
    );
  }

  return (
    <PolicyListPage
      onOpenEditor={(state) => setEditorState(state)}
    />
  );
};

export default PolicyRegistration;
